var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#222222",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9H7V16C7 16.55 7.45 17 8 17H15V16H8V9ZM16 7H10C9.45 7 9 7.45 9 8V14C9 14.55 9.45 15 10 15H16C16.55 15 17 14.55 17 14V8C17 7.45 16.55 7 16 7ZM13 8C13.83 8 14.5 8.67 14.5 9.5C14.5 10.33 13.83 11 13 11C12.17 11 11.5 10.33 11.5 9.5C11.5 8.67 12.17 8 13 8ZM16 14H10V13.25C10 12.255 12 11.75 13 11.75C14 11.75 16 12.255 16 13.25V14Z",
    fill: "url(#account_gradient)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "account_gradient",
    x1: 7,
    y1: 12,
    x2: 17,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#764BA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.4e9b1523.svg";
export { ForwardRef as ReactComponent };